module.exports = __webpack_public_path__ + "assets/media/user-member-lovel09.dde82ec6.png";